import { Component, Input, Output, EventEmitter } from '@angular/core';
import { OrderReviewService } from '../../../review/services/order-review.service';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-dmd-check-button',
  templateUrl: './dmd-check-button.component.html',
  styleUrls: ['./dmd-check-button.component.scss']
})
export class DmdCheckButtonComponent {
  @Input() customerId!: number;
  @Input() subscriberId?: string;
  @Input() isCallFromCustomerDashboard = false;
  @Output() dmdCheckResult = new EventEmitter<boolean | null>();
  @Output() dmdCheckLoading = new EventEmitter<boolean>();
  @Output() dmdCheckStatus = new EventEmitter<string>();

  constructor(
    private orderReviewService: OrderReviewService,
    private commonService: CommonService
  ) {}

  async performDmdCheck(): Promise<void> {
    try {
      // Emit loading start
      this.dmdCheckLoading.emit(true);
      
      // Show loading state
      this.commonService.startLoader();



      // Prepare DMD check payload
      const payload = {
        CustomerId: this.customerId,
      };
 
      // Perform DMD check
      const dmdResponse = await this.orderReviewService.dmdCheck(payload);

      // Hide loading state
      this.commonService.stopLoader();
      
      // Emit loading end
      this.dmdCheckLoading.emit(false);

      // Handle response
      if (dmdResponse?.data?.Status === 'Success') {
        this.commonService.showToast('success', 'Success', 'DMD check completed successfully');
        this.dmdCheckResult.emit(dmdResponse.data?.SubscriberCheckResult || false);
        this.dmdCheckStatus.emit('Success');
      } else if (dmdResponse?.data?.Status === 'Failure') {
        this.dmdCheckResult.emit(null);
        this.dmdCheckStatus.emit('Failure');
      } else {
        this.commonService.showToast('error', 'Error', 'Invalid DMD check response');
        this.dmdCheckResult.emit(null);
        this.dmdCheckStatus.emit('Invalid');
      }
    } catch (error: any) {
      // Hide loading state
      this.commonService.stopLoader();
      
      // Emit loading end
      this.dmdCheckLoading.emit(false);
      
      // Show error message
      this.commonService.showToast('error', 'Error', error?.message || 'Failed to perform DMD check');
      this.dmdCheckResult.emit(null);
      console.error('DMD Check Error:', error);
    }
  }

  private formatDateToYYYYMMDD(dateString: string): string {
    if (!dateString) return '';
    
    try {
      const date = new Date(dateString);
      
      // Check if date is valid
      if (isNaN(date.getTime())) {
        console.error('Invalid date:', dateString);
        return '';
      }
      
      // Get year, month and day
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      
      // Return formatted date
      return `${year}-${month}-${day}`;
    } catch (error) {
      console.error('Error formatting date:', error);
      return '';
    }
  }
} 